import { ALERT } from '../model/msg/alert';

let getDatas = function (urls, resolvedCallback, rejectedCallback) {
  let promises = [];

  for (let i = 0, max = urls.length; i < max; i++) {
    const promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises)
    .then(resolvedCallback)
    .fail(rejectedCallback);
};

let getDatasWithOption = function (jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  let promises = [];

  for (let i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    const promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises)
    .then(resolvedCallback)
    .fail(rejectedCallback);
};

let handleApiError = function (apiResultData, global = window) {
  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(ALERT.REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};

export {
  getDatas,
  getDatasWithOption,
  handleApiError
};


// WEBPACK FOOTER //
// ./_src/js/utils/service.js